import { DropDownElement } from '@professocial/professocialFormComponents/FormComponents/DropDownComponent'
import { RatioSelect } from '@professocial/professocialFormComponents/FormComponents/MediaCropperComponent'
import { FacebookPost, InstagramPost, NetworkType } from '@3m5/sm_publish-frontend-api'
import { ScreenEnum, ViewEnum } from '@professocial/professocialTypes/types/commonTypes'

export interface IIconProps {
  width?: string
  color?: string
  className?: string
}

export interface IPostElementProps {
  post: FacebookPost | InstagramPost | any
  networkPageId?: string
  user?: any
  networkType?: NetworkType
  value?: any
  view?: ViewEnum
  size?: ScreenEnum
  onChange?: (value: any) => void
}

export enum PostingStatus {
  success = 'success',
  error = 'error',
  pending = 'pending'
}

export enum PostSource {
  IndividualPost = 'IndividualPost',
  AutomaticAbo = 'AutomaticAbo',
  ManualAbo = 'ManualAbo',
  Unknown = 'Unknown'
}

export enum FilterType {
  template = 'template',
  topic = 'topic',
}

export enum PostingType {
  template = 'template',
  posting = 'posting',
}

export type PostPlaning = {
  start: Date | null
  end: Date | null
}

export enum PostingScreen {
  MAIN = 'MAIN',
  MEDIA = 'MEDIA',
  EMOTION = 'EMOTION',
  // LOCATION = 'LOCATION',
  TEMPLATE = 'TEMPLATE',
  TAGS = 'TAGS',
}

export enum TemplateSorting {
  new = 'new',
  popular = 'popular'
}

export interface TemplateFilter {
  category: string | DropDownElement[]
  tags: DropDownElement[]
  topic: string | DropDownElement[]
  search: string | null
  sort: TemplateSorting
  onlyFailedPostings: boolean
}

export type Resolution = {
  width?: number
  height?: number
}

export interface VideoRestriction {
  allowedFileExtensions?: string[]
  maxFileSizeInBytes?: number
  minDurationInSeconds?: number
  maxDurationInSeconds?: number
  minAspectRatio?: number | null
  maxAspectRatio?: number | null
}

export interface ImageRestriction {
  allowedFileExtensions?: string[]
  maxFileSizeInBytes?: number
  minResolution?: Resolution | null
  maxResolution?: Resolution | null
  minAspectRatio?: number | null
  maxAspectRatio?: number | null
}

export interface NetworkRatioSelection {
  [key: string]: RatioSelect[]
}

export interface NetworkRestriction {
  image?: ImageRestriction
  video?: VideoRestriction
}

export interface Restrictions {
  [key: string]: NetworkRestriction
}

export enum PostingErrorCode {
  errorImageTooLarge='errorImageTooLarge',
  errorImageRatioWrong='errorImageRatioWrong',
  errorVideoTooLarge='errorVideoTooLarge',
  errorVideoRatioWrong='errorVideoRatioWrong',
  errorMessageTooLong='errorMessageTooLong',
  errorNoNetwork='errorNoNetwork',
  errorNoImage='errorNoImage',
  errorNoMessage='errorNoMessage',
  errorNoTopic = 'errorNoTopic'
}

export interface PostingError {
  errorCode: PostingErrorCode
  network?: NetworkType
}
